import { apiSlice } from "../../app/api/apiSlice";

export const applicationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		checkQueueStatus: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/push_status_queue/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useCheckQueueStatusMutation } = applicationApiSlice;
